module.exports = __webpack_public_path__ + "img/Hamburger.bcfc9740.svg";